import { Box } from '@material-ui/core';
import { Priority } from '@nemuru-eng/js-api-client';
import React from 'react';

import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { Font } from '../../../../../../../shared/components/Font';
import { Text } from '../../../../../../../shared/components/Text';

interface PriorityTagProps {
  priority: Priority;
}

export const PriorityTag = ({ priority }: PriorityTagProps) => {
  const { palette } = useCustomTheme();

  const priorityParams = {
    [Priority.NORMAL]: {
      color: palette.grey[200],
    },
    [Priority.URGENT]: {
      color: palette.error.main,
    },
  };
  return (
    <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
      <Box height={12} width={12} borderRadius={6} bgcolor={priorityParams[priority].color} />
      <Font variant="caption" color="textSecondary" style={{ paddingLeft: 3 }}>
        <Text strong tId={priority} />
      </Font>
    </Box>
  );
};
